import type { IconData } from '@stacksjs/iconify-core'

export const envelopeOpenF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"m19.25 5.52l-8.574 7.6a1 1 0 0 1-1.331 0L.703 5.56q.095-.082.203-.152L8.359.536a3 3 0 0 1 3.282 0l7.453 4.872q.081.053.156.113zM20 7.69V18a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V7.698l8.014 6.916a3 3 0 0 0 3.992 0z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default envelopeOpenF
